// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"1fa3a2f5","732":"df4a194e","977":"56545412"}[chunkId] + ".chunk.js";
};